import { useRef } from "react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import Button from "@atlaskit/button";
import Heading from "@atlaskit/heading";
import Modal, { ModalTransition } from "@atlaskit/modal-dialog";

import {
    jswInteractiveBoardAnalyticsPayload,
    TRACKING_EVENT_NAMES
} from "../constants/analytics";
import { useInteractiveBoardStore, useMessages } from "../state";

import { CloseModalButton } from "./close-modal-button";
import {
    modalStyles,
    ctaButtonStyles,
    closeModalButtonStyles,
    descriptionStyles,
    imageStyles
} from "./success-modal.styles";

export const SuccessModal = () => {
    const [
        { isDemoCompleteModalOpen },
        { toggleCompleteDemoModalOpen, completeDemo }
    ] = useInteractiveBoardStore();
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const [messages] = useMessages();

    const ctaRef = useRef<HTMLAnchorElement>(null);

    function onClose() {
        createAnalyticsEvent({
            ...jswInteractiveBoardAnalyticsPayload,
            attributes: {
                eventName:
                    TRACKING_EVENT_NAMES.jswInteractiveBoardSuccessModalGetStarted,
                isDemoComplete: true
            }
        }).fire();

        void toggleCompleteDemoModalOpen();

        // TODO: Move logic to onCloseComplete once bug is fixed
        // https://product-fabric.atlassian.net/browse/DSP-3926
        setTimeout(() => {
            createAnalyticsEvent({
                ...jswInteractiveBoardAnalyticsPayload,
                attributes: {
                    eventName:
                        TRACKING_EVENT_NAMES.jswInteractiveBoardSuccessModalClosed,
                    isDemoComplete: true
                }
            }).fire();

            void completeDemo();
        }, 500);
    }

    return (
        <ModalTransition>
            {isDemoCompleteModalOpen && (
                <Modal
                    label={messages.successModalHeading}
                    onClose={onClose}
                    width={440}
                    // Disabling because this follows atlaskit pattern https://atlassian.design/components/modal-dialog/examples#focus-management
                    // eslint-disable-next-line jsx-a11y/no-autofocus
                    autoFocus={ctaRef}
                >
                    <div css={modalStyles}>
                        <CloseModalButton
                            onCloseClick={onClose}
                            styleOverrides={closeModalButtonStyles}
                        />
                        <div css={imageStyles}>
                            <img
                                alt=""
                                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/checkmark-paper-plane-illustration.webp"
                            />
                        </div>
                        <Heading as="h2" level="h600">
                            {messages.successModalHeading}
                        </Heading>
                        <p css={descriptionStyles}>
                            {messages.successModalDescription}
                        </p>
                        <Button
                            css={ctaButtonStyles}
                            appearance="warning"
                            href="/software/jira/free"
                            onClick={onClose}
                            ref={ctaRef}
                        >
                            {messages.successModalCtaButton}
                        </Button>
                    </div>
                </Modal>
            )}
        </ModalTransition>
    );
};
